module.exports = __webpack_public_path__ + "img/hokkaido_chopped.4efe24aa.jpg";